/**
 * Modular What's New entries for the "businessAi" module: Happy AI business digest, alerts and goals. `routes` use the real navigation screen names from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const businessAiEntries = [
  {
    id: 'business-digest-alerts-goals-2026-10',
    module: 'businessAi',
    routes: ['BusinessDigestScreen', 'BusinessAlertsScreen', 'BusinessGoalsScreen'],
    date: '2026-10-21',
    version: '4.15.1',
    global: true,
    type: 'feature',
    title: {
      en: "📈 Your business digest, alerts and goals",
      hu: "📈 Üzleti összefoglaló, riasztások és célok",
      de: "📈 Ihr Business-Digest, Warnungen und Ziele",
      cn: "📈 业务摘要、警报和目标",
      ro: "📈 Rezumatul afacerii, alerte și obiective",
      svn: "📈 Poslovni povzetek, opozorila in cilji",
    },
    body: {
      en: "Happy AI now writes a daily and weekly digest of how the business is doing, raises alerts when a number moves in the wrong direction, and tracks the goals you set. Filter alerts by severity, then acknowledge, dismiss or reopen them in a tap. Choose when the digest arrives and whether it comes by push or e-mail.",
      hu: "A Happy AI mostantól napi és heti összefoglalót ír arról, hogyan megy az üzlet, riaszt, ha egy mutató rossz irányba mozdul, és követi a kitűzött céljaidat. A riasztásokat súlyosság szerint szűrheted, majd egy koppintással nyugtázhatod, elvetheted vagy újranyithatod őket. Beállíthatod, mikor érkezzen az összefoglaló, és hogy pushban vagy e-mailben kéred.",
      de: "Happy AI schreibt jetzt einen täglichen und wöchentlichen Digest zur Geschäftslage, warnt, wenn sich eine Kennzahl in die falsche Richtung bewegt, und verfolgt die von Ihnen gesetzten Ziele. Warnungen lassen sich nach Schweregrad filtern und mit einem Tipp bestätigen, verwerfen oder wieder öffnen. Sie legen fest, wann der Digest kommt und ob per Push oder E-Mail.",
      cn: "Happy AI 现在会撰写每日和每周的业务摘要，在某项指标走向不利时发出警报，并跟踪你设定的目标。可按严重程度筛选警报，并一键确认、忽略或重新打开。你可以设置摘要的送达时间，以及通过推送还是邮件接收。",
      ro: "Happy AI scrie acum un rezumat zilnic și săptămânal despre cum merge afacerea, dă alerte când o cifră se mișcă în direcția greșită și urmărește obiectivele pe care le stabilești. Filtrezi alertele după gravitate, apoi le confirmi, le respingi sau le redeschizi dintr-o atingere. Alegi când sosește rezumatul și dacă vine prin push sau e-mail.",
      svn: "Happy AI zdaj piše dnevni in tedenski povzetek stanja poslovanja, opozori, ko se kazalnik premakne v napačno smer, in spremlja cilje, ki ste jih postavili. Opozorila filtrirate po resnosti, nato jih z dotikom potrdite, zavrnete ali znova odprete. Izberete, kdaj povzetek prispe in ali po push obvestilu ali e-pošti.",
    },
  },
];

export default businessAiEntries;
